import React, { useState, useEffect } from 'react';
import CountUp from 'react-countup';

type DayFilter = 'yesterday' | 'today' | 'upcoming';

export function UnderdogHypeBottomSheet({
  dayFilter,
}: {
  dayFilter: DayFilter;
}) {
  const [wins, setWins] = useState(0);
  const [highlights, setHighlights] = useState(0);
  const [totalGames, setTotalGames] = useState(0);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [hasFinals, setHasFinals] = useState(false);

  const refresh = () => {
    setWins(document.getElementsByClassName('underdog-hype-winner').length);
    setHighlights(document.getElementsByClassName('underdog-highlight').length);
    setTotalGames(document.getElementsByClassName('matchup-tile').length);
  
    const finals = document.getElementsByClassName('status-final').length;
    setHasFinals(finals > 0);
  };
  

  useEffect(() => {
    refresh();
    const obs = new MutationObserver(refresh);
    obs.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
    return () => obs.disconnect();
  }, []);

  const picks = wins + highlights;
  const pct   = picks ? Math.round((wins / picks) * 100) : 0;

  const sheetStyle: React.CSSProperties = {
    position:   'fixed',
    bottom:     0,
    left:       0,
    width:      '100%',
    background: '#1e1e1e',
    color:      '#f0f0f0',
    boxShadow:  '0 -4px 12px rgba(0,0,0,0.5)',
    zIndex:     9999,
    fontFamily: '"Segoe UI", sans-serif',
  };

  const inner: React.CSSProperties = {
    maxWidth:      1024,
    margin:        '0 auto',
    display:       'flex',
    justifyContent:'space-around',
    padding:       '1rem',
    alignItems:    'center',
  };

  const block: React.CSSProperties = {
    textAlign: 'center',
  };

  const label: React.CSSProperties = {
    fontSize:      '0.75rem',
    color:         '#aaa',
    marginBottom:  '0.25rem',
    textTransform: 'uppercase',
  };

  const value: React.CSSProperties = {
    fontSize:   '1.5rem',
    fontWeight: 600,
    lineHeight: 1,
  };

  const dashStyle: React.CSSProperties = {
    ...value,
    color: '#555',
  };

  return (
    <div style={sheetStyle}>
      <div style={inner}>
        {/* Wins */}
        <div style={block}>
          <div style={label}>Wins</div>
          {dayFilter === 'upcoming' ? (
            <div style={dashStyle}>—</div>
          ) : (
            <div style={value}>
              <CountUp end={wins} duration={0.5} redraw />
            </div>
          )}
        </div>

        {/* Picks */}
        <div style={block}>
          <div style={label}>Picks</div>
          <div style={value}>
            <CountUp end={picks} duration={0.5} redraw />
          </div>
        </div>

        {/* Total Games */}
        <div style={block}>
          <div style={label}>Total Games</div>
          <div style={value}>
            <CountUp end={totalGames} duration={0.5} redraw />
          </div>
        </div>

        {/* Accuracy */}
        <div style={block}>
          <div style={label}>Accuracy</div>
          {dayFilter === 'upcoming' ? (
            <div style={dashStyle}>—</div>
          ) : (
            <div style={{ ...value, color: '#ffd500' }}>
              <CountUp end={pct} duration={0.5} suffix="%" redraw />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
